import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { AddCartLinesApiParameter } from "@insite/client-framework/Services/CartService";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    PopulateAddLineCollectionApiParameter,
} from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/PlaceOrder";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { replaceInChain } from "@ucs/Store/CustomHandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<
    { order?: CartModel } & HasOnSuccess & HasOnError<string>,
    AddCartLinesApiParameter,
    CartModel
>;

export const PopulateAddLineCollectionApiParameterKeepOutOfStock: HandlerType = props => {
    const state = props.getState();
    const order = props.parameter.order ?? getCartState(state, state.pages.savedOrderDetails.cartId).value;
    if (!order) {
        throw new Error("PlaceOrder was called but there was no order");
    }

    const availableLines = order.cartLines!.filter(cartLine => cartLine.canAddToCart);
    props.apiParameter = {
        cartId: API_URL_CURRENT_FRAGMENT,
        cartLineCollection: {
            cartLines: availableLines,
        },
    } as AddCartLinesApiParameter;
};

replaceInChain(chain, PopulateAddLineCollectionApiParameter, PopulateAddLineCollectionApiParameterKeepOutOfStock);
